moment = require('moment')

module.exports = (arachnysMinDate, arachnysMaxDate, arachnysOutputDateFormat, arachnysAcceptableDateInputFormats) ->
  min = moment(arachnysMinDate)
  max = moment(arachnysMaxDate)

  return {
    require: 'ngModel'
    # To add this parser before Datepicker's, we link after
    # it and unshift onto the beginning of $parsers
    priority: 1
    link: (scope, element, attrs, ngModelController) ->
      ngModelController.$parsers.unshift (date) ->
        # If user has typed a non-empty string attempt to parse using moment
        if typeof (date) == 'string' and date != ''
          dateMoment = moment(date, arachnysAcceptableDateInputFormats, 'en', true)
          valid = dateMoment.isValid() and dateMoment.isSameOrAfter(min) and dateMoment.isSameOrBefore(max)
          parsed = if valid then dateMoment.format(arachnysOutputDateFormat) else undefined

        # In other cases, i.e. empty string or choice of date from datepicker, pass through
        else
          valid = true
          parsed = date

        ngModelController.$setValidity('format', valid)
        return parsed
  }
